



















import { defineComponent } from '@vue/composition-api';
import { CREATION_SUBMIT_ICON } from '../const';
const gifCreationSuccess = CREATION_SUBMIT_ICON.SUCCESS;

export default defineComponent({
  props: {
    isMultipleCountry: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      gifCreationSuccess,
    };
  },
});
